import { GridAlignment, GridFilterModel, GridSortModel } from "@mui/x-data-grid";

export interface ColumnModel {
  columns: ColumnModelItem[];
  sorting?: {
    sortModel?: GridSortModel;
  };
  fitler?: {
    filterModel?: GridFilterModel;
  };
}

export interface ColumnModelItem {
  id: string;
  // Unique field identifier for the data table
  field: string;
  headerName: string;
  
  // Custom options
  abbreviate?: boolean;
  color?: string;
  order?: number;
  showRenderTypeInSettings?: boolean;
  
  // Agg Fields from API
  fieldType: string;
  filter?: string[] | [];
  labels?: string[] | [],
  operator?: string; // coorelates to "op" in Agg
  
  // The name of the field from the API
  sourceField: string;
  hidden?: boolean;
  hasHeaderOptions?: boolean;

  // GridColDef options
  align?: GridAlignment;
  description?: string;
  headerAlign?: GridAlignment;
  disableColumnMenu?: boolean;
  renderType?: ColumnRenderType | undefined;
  renderCell?: any;
  maxWidth?: number;
  minWidth?: number;
  width?: number;
}

export enum ColumnRenderType {
  Chip = "chip",
  Colorbox = "colorbox",
  DistributionBar = "distributionBar",
  Integer = "number",
  LatitudeLongitude = "latitude_longitude",
  Number = "number",
  Percent = "percent",
  PercentChange = "percent_change",
  SentimentBar = "sentimentBar",
  Text = "text",
  Timestamp = "timestamp",
}

export enum ColumnToolbarType {
  RECORD_TABLE = "Record Table",
  DATA_TABLE = "Data Table",
  TOPIC_TABLE = "Topic Table",
  QUERY_COMPARISON_TABLE = "Query Comparison Table",
}

export enum ColumnDialogMode {
  ADD_COLUMN = "add-column",
  UPDATE_CATEGORY = "update-category",
  UPDATE_COLUMN = "update-column"
}

export type ColumnDialogParams = 
  | {
      mode: ColumnDialogMode.UPDATE_COLUMN,
      activeColumnIndex: number,
      activeField: string
    }
  | { mode: ColumnDialogMode.ADD_COLUMN }
  | { mode: ColumnDialogMode.UPDATE_CATEGORY }
  | { mode: ColumnDialogMode.ADD_COLUMN, newColumns: ColumnModelItem[] };